import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import FormNumber from '../../components/form/FormNumber/FormNumber';

const FormNumberContainer = props =>
  <Field
    name={props.name}
    component={FormNumber}
    props={props}
  />
;

FormNumberContainer.propTypes = {
  name: PropTypes.string
};

export default FormNumberContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/FormNumberContainer.js
 **/